import * as Types from '../../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UploadAssetMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
  assetVersion: Types.Scalars['String'];
}>;


export type UploadAssetMutation = { __typename?: 'MutationRoot', uploadAsset: { __typename?: 'Course', id: string } };

export type GetAssetVersionQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetAssetVersionQuery = { __typename?: 'QueryRoot', course: { __typename?: 'Course', assetVersion: string } };


export const UploadAssetDocument = gql`
    mutation UploadAsset($id: String!, $assetVersion: String!) {
  uploadAsset(input: {id: $id, assetVersion: $assetVersion}) {
    id
  }
}
    `;

export function useUploadAssetMutation() {
  return Urql.useMutation<UploadAssetMutation, UploadAssetMutationVariables>(UploadAssetDocument);
};
export const GetAssetVersionDocument = gql`
    query GetAssetVersion($id: String!) {
  course(id: $id) {
    assetVersion
  }
}
    `;

export function useGetAssetVersionQuery(options: Omit<Urql.UseQueryArgs<GetAssetVersionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAssetVersionQuery, GetAssetVersionQueryVariables>({ query: GetAssetVersionDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadAssetMutation((req, res, ctx) => {
 *   const { id, assetVersion } = req.variables;
 *   return res(
 *     ctx.data({ uploadAsset })
 *   )
 * })
 */
export const mockUploadAssetMutation = (resolver: ResponseResolver<GraphQLRequest<UploadAssetMutationVariables>, GraphQLContext<UploadAssetMutation>, any>) =>
  graphql.mutation<UploadAssetMutation, UploadAssetMutationVariables>(
    'UploadAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAssetVersionQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ course })
 *   )
 * })
 */
export const mockGetAssetVersionQuery = (resolver: ResponseResolver<GraphQLRequest<GetAssetVersionQueryVariables>, GraphQLContext<GetAssetVersionQuery>, any>) =>
  graphql.query<GetAssetVersionQuery, GetAssetVersionQueryVariables>(
    'GetAssetVersion',
    resolver
  )
